import CircularProgress from "@mui/material/CircularProgress"; // Asegúrate de tener instalado @mui/material
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const TranspSpinner = ({ porcentaje }) => {
  return (
    <div className="spinnerContainer">
      <div className="loader-container">
        <CircularProgress className="spinnerTrans" />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
          >{`${Math.round(porcentaje)}%`}</Typography>
        </Box>
      </div>
    </div>
  );
};
